import { render, staticRenderFns } from "./customerquery.vue?vue&type=template&id=cfeb6ce2&scoped=true"
import script from "./customerquery.vue?vue&type=script&lang=js"
export * from "./customerquery.vue?vue&type=script&lang=js"
import style0 from "./customerquery.vue?vue&type=style&index=0&id=cfeb6ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeb6ce2",
  null
  
)

export default component.exports